import React from 'react';

const LocationIcon = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.99996 9.72614C8.70039 9.72614 7.64282 8.68409 7.64282 7.4036C7.64282 6.1231 8.70039 5.08105 9.99996 5.08105C11.2995 5.08105 12.3571 6.1231 12.3571 7.4036C12.3571 8.68409 11.2995 9.72614 9.99996 9.72614ZM9.99996 6.62942C9.56704 6.62942 9.21425 6.97702 9.21425 7.4036C9.21425 7.83095 9.56704 8.17778 9.99996 8.17778C10.4329 8.17778 10.7857 7.83095 10.7857 7.4036C10.7857 6.97702 10.4329 6.62942 9.99996 6.62942Z"
      fill="#959595"
    />
    <path
      d="M10 17.9844C8.1465 15.548 4.5 10.4508 4.5 7.40364C4.5 4.4153 6.96714 1.98438 10 1.98438C13.0329 1.98438 15.5 4.4153 15.5 7.40364C15.5 10.4508 11.8535 15.5488 10 17.9844ZM10 3.53274C7.83379 3.53274 6.07143 5.26923 6.07143 7.40364C6.07143 9.40955 8.51264 13.2743 10 15.3707C11.4866 13.2735 13.9286 9.408 13.9286 7.40364C13.9286 5.26923 12.1662 3.53274 10 3.53274Z"
      fill="#959595"
    />
  </svg>
);

export default LocationIcon;
